import Vue from "vue";
import VueI18n from "vue-i18n";
import { findUrlParam } from "@/mixins/methods";

// Importer les messages de traduction
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import de from "./locales/de.json";
import nl from "./locales/nl.json";

Vue.use(VueI18n);

const messages = {
	en: en,
	fr: fr,
	es: es,
	it: it,
	de: de,
	nl: nl
};

const i18n = new VueI18n({
	locale: findUrlParam("lang") ?? "fr",
	messages
});
const replaceSoftwareName = (text, name) => {
	if (typeof text !== "string") return text;
	return text
		.replace(/Sinao/g, name ?? "Sinao")
		.replace(/sinao/g, name);
};


i18n.softwareName = "Sinao";
const originalT = i18n.t.bind(i18n);

i18n.t = function (...args) {
	let translation = originalT(...args);
	if (typeof translation === "string")
		return replaceSoftwareName(translation, this.softwareName);

	if (Array.isArray(translation))
		return translation.map(item => replaceSoftwareName(item, this.softwareName));

	return translation;
};

Vue.prototype.$t = function (...args) {
	return i18n.t(...args);
};

export default i18n;
